import React, { useState } from 'react';
import { Bell } from 'lucide-react';
import api from '../services/api';

interface Props {
  unreadCount: number;
  onRefresh: () => void;
}

const NotificationBell: React.FC<Props> = ({ unreadCount, onRefresh }) => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.getNotifications();
      setItems(res.data?.notifications || []);
      onRefresh();
    } finally {
      setLoading(false);
    }
  };

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next) await load();
  };

  return (
    <div style={{ position: 'relative' }}>
      <button
        type="button"
        aria-label="Bildirimler"
        onClick={toggle}
        style={{
          background: 'rgba(51,65,85,0.35)',
          border: '1px solid rgba(51,65,85,0.25)',
          borderRadius: '10px',
          padding: '8px',
          cursor: 'pointer',
          color: '#e2e8f0',
          display: 'flex',
          position: 'relative',
        }}
      >
        <Bell size={18} />
        {unreadCount > 0 && (
          <span
            style={{
              position: 'absolute',
              top: 2,
              right: 2,
              minWidth: 16,
              height: 16,
              borderRadius: 999,
              background: '#ef4444',
              color: 'white',
              fontSize: 10,
              fontWeight: 700,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '0 4px',
            }}
          >
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      {open && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 8px)',
            right: 0,
            width: 320,
            maxHeight: 360,
            overflowY: 'auto',
            background: 'rgba(15,23,42,0.98)',
            border: '1px solid rgba(51,65,85,0.35)',
            borderRadius: '14px',
            boxShadow: '0 20px 50px rgba(0,0,0,0.45)',
            zIndex: 9999,
            padding: '8px',
          }}
        >
          {loading ? (
            <p style={{ padding: 12, color: '#64748b', fontSize: 13, margin: 0 }}>Yükleniyor...</p>
          ) : items.length === 0 ? (
            <p style={{ padding: 12, color: '#64748b', fontSize: 13, margin: 0 }}>Bildirim yok</p>
          ) : (
            items.slice(0, 12).map((n) => (
              <button
                key={n._id}
                type="button"
                onClick={async () => {
                  if (!n.isRead) await api.markNotificationRead(n._id);
                  onRefresh();
                  load();
                }}
                style={{
                  display: 'block',
                  width: '100%',
                  textAlign: 'left',
                  padding: '10px 12px',
                  border: 'none',
                  borderRadius: '10px',
                  background: n.isRead ? 'transparent' : 'var(--accent-primary-soft)',
                  cursor: 'pointer',
                  marginBottom: 4,
                }}
              >
                <div style={{ fontWeight: 600, color: '#e2e8f0', fontSize: 13 }}>{n.title}</div>
                <div style={{ color: '#64748b', fontSize: 12, marginTop: 4 }}>{n.message}</div>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
